import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class JwtService {
  /**
   * Get JWT from local storage
   * @method getToken
   * @returns {string} JWT
   */
  getToken(): string {
    return window.localStorage['jwtToken'];
  }

  /**
   * Save JWT to local storage
   * @method saveToken
   * @param token JWT
   */
  saveToken(token: string) {
    window.localStorage['jwtToken'] = token;
  }

  /**
   * Destroy JWT in local storage
   * @method destroyToken
   */
  destroyToken() {
    window.localStorage.removeItem('jwtToken');
  }
}
